module.exports = __webpack_public_path__ + "img/1-1.c77b1902.png";